import { make } from 'vuex-pathify'

const createState = () => ({
  selected: [],
  places: [],
  stops: [],
  payload: [],
  advertised_train_ident: null,
  scheduled_departure_date_time: null
})

const state = createState()

const mutations = make.mutations(state)

const getters = {
  currentProductinformation(state) {
    const items = state.selected
      .map(x => x.product_information || [])
      .flat()
      .map(x => x.code)

    return [...new Set(items)]
  },

  currentServices(state) {
    const items = state.selected
      .map(x => x.service || [])
      .flat()
      .map(x => x.code)

    return [...new Set(items)]
  },

  currentDeviations(state) {
    const items = state.selected.map(x => x.deviation || []).flat()

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.code]) {
          acc[item.code] = {
            code: item.code,
            parameters: (item.parameters || []).map(x => ({
              name: x.name,
              value: x.value
            }))
          }
        }

        return acc
      }, {})
    )
  },

  currentBookings(state) {
    const items = state.selected
      .map(x => x.booking || [])
      .flat()
      .map(x => x.code)

    return [...new Set(items)]
  },

  currentOtherInformation(state) {
    const items = state.selected.map(x => x.other_information || []).flat()

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.code]) {
          acc[item.code] = {
            code: item.code,
            parameters: (item.parameters || []).map(x => ({
              name: x.name,
              value: x.value
            }))
          }
        }

        return acc
      }, {})
    )
  },

  currentTrainCompositions(state) {
    const items = state.selected.map(x => x.train_composition || []).flat()

    return Object.values(
      items.reduce((acc, item) => {
        if (!acc[item.code]) {
          acc[item.code] = {
            code: item.code,
            parameters: (item.parameters || []).map(x => ({
              name: x.name,
              value: x.value
            }))
          }
        }

        return acc
      }, {})
    )
  },

  currentViaFromLocation(state) {
    const items = state.selected.map(x => x.via_from_location || []).flat()

    return [...new Set(items)]
  },

  currentViaToLocation(state) {
    const items = state.selected.map(x => x.via_to_location || []).flat()

    return [...new Set(items)]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
